import { parseISO, isValid } from 'date-fns';
import { TableDataItem } from '../types';

const normalizeFlowType = (value?: string): string => {
 
  switch (value) {
    case 'TubularFlow':
      return 'Tubular Flow';
    case 'AnnularFlow':
      return 'Annular Flow';
    case 'TubingAndAnnularFlow':
      return 'Tubing & Annular Flow';
    default:
      return value || '—';
  }
};

const guessFlowPath = (data: TableDataItem): string => {
  const guessed = data.InjectionRate && Number(data.InjectionRate) > 0 ? 'AnnularFlow' : 'TubularFlow';
  console.log('Guessing FlowPath:', guessed, 'from InjectionRate:', data.InjectionRate);
  return guessed;
};

/** Converts date string (MM/DD/YYYY, MMM d yyyy, or ISO) to ISO; returns '' for invalid/empty to avoid crash. */
function convertToISOString(dateStr: string | null | undefined): string {
  if (dateStr == null || String(dateStr).trim() === '') return '';
  const str = String(dateStr).trim();
  let date: Date;
  if (str.includes('/')) {
    const parts = str.split('/').map(Number);
    if (parts.length >= 3 && parts.every((n) => !Number.isNaN(n))) {
      const [month, day, year] = parts;
      date = new Date(Date.UTC(year, month - 1, day));
    } else {
      date = new Date(str);
    }
  } else {
    date = parseISO(str);
    if (!isValid(date)) date = new Date(str);
  }
  if (!isValid(date) || Number.isNaN(date.getTime())) return '';
  return date.toISOString();
}

export const mapGLTableDataToFormData = (data: TableDataItem): Partial<any> => {
  return {
    oil: data.Oil?.toString() || '',
    water: data.Water?.toString() || '',
    gas: data.Gas?.toString() || '',
    tubingHeadPressure: data.WellheadPressure?.toString() || '',
    wellheadTemperature: data.WellheadTemperature?.toString() || '',
    casingPressure: data.CasingPressure?.toString() || '',
    flowlinePressure: data.FlowlinePressure?.toString() || '',
    productionChokePosition: data.ProductionChokePosition?.toString() || '',
    downholePressure: data.DownholePressure?.toString() || '',
    downholeTemperature: data.DownholeTemperature?.toString() || '',
    injectionRate: data.InjectionRate?.toString() || '',
    injectionChoke: data.InjectionChoke?.toString() || '',
    waterDensity: data.WaterDensity?.toString() || '',
    reservoirPressure:
      data.ReservoirPressure !== null && data.ReservoirPressure !== undefined ? data.ReservoirPressure.toString() : '',

    pwf: data.ResultsPwf !== null && data.ResultsPwf !== undefined ? Number(data.ResultsPwf).toFixed(2) : '',
    productivityIndex:
      data.ProductivityIndex !== null && data.ProductivityIndex !== undefined
        ? Number(data.ProductivityIndex).toFixed(2)
        : '',
    flowType: normalizeFlowType(data.FlowPathString || guessFlowPath(data)),

    comment: typeof data.Comment === 'string' ? data.Comment : '-',
    enabled: data.Enabled === 'N' ? false : true,
    date: convertToISOString(data.Date),
    id: data.Id || 0,
    wellId: data.WellId || 0,
  };
};
